/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LegalTeamSize {
  One = "1",
  TwoToFive = "2 - 5",
  SixToTen = "6 - 10",
  ElevenToTwenty = "11 - 20",
  TwentyOneToFortyNine = "21 - 49",
  FiftyPlus = "50+",
}

export const LegalTeamSizeDisplay: Record<LegalTeamSize, string> = {
  [LegalTeamSize.One]: "1",
  [LegalTeamSize.TwoToFive]: "2 - 5",
  [LegalTeamSize.SixToTen]: "6 - 10",
  [LegalTeamSize.ElevenToTwenty]: "11 - 20",
  [LegalTeamSize.TwentyOneToFortyNine]: "21 - 49",
  [LegalTeamSize.FiftyPlus]: "50+",
};
